import React, {useMemo} from 'react'
import {Row, Col, H6, Caption} from '@modifi/ui'
import {uploadFormComponents} from '@modifi/plugin-documents'
import {airBlue, mediumGray} from '@modifi/colors'
import {useTranslation} from '@modifi/plugin-i18n'

import {StyledCol} from './styles'

type DocumentTypeRowProps = {
  onPartnerFileSelection: (files: FileList | File[]) => void
  documentType: string
  isDisabled?: boolean
  multiple?: boolean
  components?: {
    documentTypeHeadlineCol?: React.ElementType
    documentTypeLabel?: React.ElementType
    documentTypeActionsCol?: React.ElementType
  } | null
}

const DocumentTypeRow: React.VFC<DocumentTypeRowProps> = ({
  components = null,
  onPartnerFileSelection,
  documentType,
  multiple = false,
  isDisabled = false,
}) => {
  const {t} = useTranslation('charon')

  // eslint-disable-next-line no-shadow
  const DocumentTypeActionsCol =
    components?.documentTypeActionsCol || uploadFormComponents.DocumentTypeActionsCol

  return (
    <Row justifyContent="center">
      <Col>
        <H6 color={isDisabled ? mediumGray : airBlue} textAlign="center">
          {t('custom.document-type-row.heading')}
        </H6>
      </Col>
      <StyledCol>
        <Caption>{t('custom.document-type-row.sub-heading')}</Caption>
      </StyledCol>
      <Col auto mt={16}>
        {useMemo(
          () => (
            <DocumentTypeActionsCol
              documentType={documentType}
              onPartnerFileSelection={onPartnerFileSelection}
              multiple={multiple}
              isDisabled={isDisabled}
            />
          ),
          [DocumentTypeActionsCol, documentType, isDisabled, multiple, onPartnerFileSelection]
        )}
      </Col>
    </Row>
  )
}

export default DocumentTypeRow
